import React, { useCallback } from "react";
import { useSetAtom } from "jotai";
import { useItemGroups } from "atoms/itemsGropAtom";
import { setSettingsModalGroupAtom } from "atoms/modalAtom/modalAtom";
import { allItemGroups } from "constant-data/items";

import { Button } from "components/Button/Button";

export function SettingsButton() {
  const { itemGroupsState } = useItemGroups();
  const setSettingsModalGroup = useSetAtom(setSettingsModalGroupAtom);

  const handleClick = useCallback(() => {
    if (itemGroupsState.activeItemsGroup) {
      setSettingsModalGroup(true);
    }
  }, [itemGroupsState, setSettingsModalGroup]);

  return (
    <Button
      icon="settings"
      onClick={handleClick}
      disabled={
        !itemGroupsState.activeItemsGroup ||
        itemGroupsState.activeItemsGroup.itemgroupid ===
          allItemGroups.itemgroupid
      }
    >
      Свойства
    </Button>
  );
}
